// extracted by mini-css-extract-plugin
module.exports = {"imageBadge":"ImageBage_imageBadge__AKb_v","href":"ImageBage_href__ILkJm"};